import { render, staticRenderFns } from "./SdsSteel.vue?vue&type=template&id=1a585c3d&scoped=true&"
import script from "./SdsSteel.vue?vue&type=script&lang=js&"
export * from "./SdsSteel.vue?vue&type=script&lang=js&"
import style0 from "./SdsSteel.vue?vue&type=style&index=0&id=1a585c3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a585c3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup,VTextField})
